// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._16jlkb7n{flex-grow:1}
._185bglyw._185bglyw>[hidden]{display:none}
._18i0kb7n [role=tabpanel]{flex-grow:1}
._1c3y1txw [role=tabpanel]{display:flex}
._1e0c1txw{display:flex}
._1tkeidpf{min-height:0}
._2lx21bp4{flex-direction:column}
._ftfaidpf [role=tabpanel]{min-height:0}
._i0dl1osq{flex-basis:100%}
._p12f1osq{max-width:100%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-picker/node_modules/@atlaskit/tabs/dist/esm/components/tabs.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,8BAA8B,YAAY;AAC1C,2BAA2B,WAAW;AACtC,2BAA2B,YAAY;AACvC,WAAW,YAAY;AACvB,WAAW,YAAY;AACvB,WAAW,qBAAqB;AAChC,2BAA2B,YAAY;AACvC,WAAW,eAAe;AAC1B,WAAW,cAAc","sourcesContent":["._16jlkb7n{flex-grow:1}\n._185bglyw._185bglyw>[hidden]{display:none}\n._18i0kb7n [role=tabpanel]{flex-grow:1}\n._1c3y1txw [role=tabpanel]{display:flex}\n._1e0c1txw{display:flex}\n._1tkeidpf{min-height:0}\n._2lx21bp4{flex-direction:column}\n._ftfaidpf [role=tabpanel]{min-height:0}\n._i0dl1osq{flex-basis:100%}\n._p12f1osq{max-width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
